import { createI18n } from 'vue-i18n'
import ru from './locales/ru/translation.json'
import kg from './locales/kg/translation.json'

const detectLang = () => {
  const stored = localStorage.getItem('i18nextLng')
  if (stored) return stored

  const browserLang = navigator.language.split('-')[0]
  return ['kg', 'ru'].includes(browserLang) ? browserLang : 'kg'
}

const locale = detectLang()

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'kg',
  messages: {
    ru,
    kg,
  }
})
